import { useForm } from "react-hook-form";
import dayjs from "dayjs";

import { comboApi } from "src/1/apis/combo.api";
import { history } from "src/App";

import { ComboForm } from "../../components";
import { comboDefaultValues, comboResolver } from "../../form";

const ThemDeXuatCombo = () => {
  //#region Data
  const { control, handleSubmit, reset } = useForm({
    mode: "all",
    defaultValues: comboDefaultValues,
    resolver: comboResolver,
  });
  //#endregion

  //#region Event
  const onSubmit = handleSubmit(
    async (values) => {
      try {
        const payload = {
          ...values,
          file_id: values?.file_id?.id,
          from: dayjs(values?.from).format("YYYY-MM-DD"),
          to: dayjs(values?.to).format("YYYY-MM-DD"),
          portion_file_id: values?.portion_file,
          product_file_id: values?.product_file,
        };
        await comboApi.createProposal(payload);
        noti("success", "Tạo đề xuất combo thành công!");
        reset(comboDefaultValues);
        history.push("/combos/suggest-list");
      } catch (error) {
        noti("error", error?.message ?? "Thêm đề xuất combo thành công!");
      }
    },
    (errors) => {
      const firstMessage = Object.values(errors)?.[0]?.message;
      noti("error", firstMessage);
    },
  );
  //#endregion

  //#region Render
  return <ComboForm control={control} onSubmit={onSubmit} />;
  //#endregion
};
export default ThemDeXuatCombo;
